import { useStores } from '~store';

export default function useOrderDispatchHiddenFields() {
  const { companySettings } = useStores().userStore;

  return {
    hideEquipmentType: companySettings.isEnabled(
      'hide_dispatch_orders_equipment_type_column',
    ),
    hideMaterials: companySettings.isEnabled('hide_dispatch_orders_materials_column'),
    hidePickupAndDropoff: companySettings.isEnabled(
      'hide_dispatch_orders_pickup_dropoff_column',
    ),
    hideStartTime: companySettings.isEnabled('hide_dispatch_orders_start_time_column'),
  };
}
